<tabset>
  <tab heading="Data">
    <div class="row" *ngIf="widgetType">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Name</label>
              <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name"/>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Period</label>
              <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Refresh (Seconds)</label>
              <input min="60" type="text" placeholder="refresh interval" class="form-control" [(ngModel)]="w.refreshInterval"/>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Map Zoom</label>
              <input type="number" min="0" max="20" placeholder="zoomLevel" class="form-control" [(ngModel)]="w.zoomLevel"/>     
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Widget Size</label>
              <select [(ngModel)]="w.size" class="input-group form-select">
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Widget Height</label>
              <select [(ngModel)]="w.height" class="input-group form-select">
                <option value="400">400</option>
                <option value="450">450</option>
                <option value="500">500</option>
                <option value="600">600</option>
                <option value="700">700</option>
              </select>
            </div>
          </div>
          
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Map Type</label>
              <select [(ngModel)]="w.mapType" class="input-group form-select">
                <option value="googleTerrain">Terrain</option>
                <option value="googleStreets">Streets</option>
                <option value="googleSat">Satellite</option>
              </select>
            </div>
          </div>
        
          <div class="col-lg-4">
            <div class="form-group input-group-sm">
              <label>Map Overlay (GEO JSON)</label>
              <input *ngIf="w.geoJson == null" type="file" class="form-control" (change)="uploadShapeFile(w, $event.target.files)" placeholder="Upload file" accept=".json,.geojson"/>                          
              <input *ngIf="w.geoJson" type="text" class="form-control" [(ngModel)]="w.geoJson"/>
            </div>
          </div>
        
          <div class="col-lg-3">
            <div class="form-group input-group-sm mt-2">
                <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        
      </div>  
    </div>
    <div class="row mb-3 mt-3">
      <div class="col-lg-2">
        <button (click)="addTracker()" class="btn btn-primary btn-block" type="submit">
          <i class="fa fa-line-chart"></i> Add Tracker
        </button>
      </div>
      <div class="col-lg-2">
        <button (click)="addGeoJson()" class="btn btn-primary btn-block" type="submit">
          <i class="fa fa-line-chart"></i> Add GEO JSON
        </button>
      </div>
      <div class="col-lg-2">
        <button (click)="addFixed()" class="btn btn-primary btn-block" type="submit">
          <i class="fa fa-line-chart"></i> Add Fixed
        </button>
      </div>
      <div class="col-lg-2">
        <button (click)="addHeatmap()" class="btn btn-primary btn-block" type="submit">
          <i class="fa fa-line-chart"></i> Add Heat Map
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <tabset>
          <tab *ngFor="let tab of w.timeSeriesDetailList" 
            [heading]="tab.name == null ? tab.type : tab.name" 
            [active]="tab.active" 
            [heading]="tab.uri == null ? 'Not Set' : tab.displayName == '' || tab.displayName == null ? tab.uri : tab.displayName"
            (select)="tab.active = true"
            (deselect)="tab.active = false" 
            [disabled]="tab.disabled"
            [removable]="tab.removable"
            (removed)="removeTimeSeries(tab)">
            <div class="row mt-3">
              <div  class="col-lg-4" [ngClass]="{'col-lg-4':tab.type == 'fixed','col-lg-12':tab.type != 'fixed'}" *ngIf="!widget.tagMatch">
                <div class="form-group input-group-sm">
                  <label>Select Time Series <button [style.background]="tab.colour" [cpPosition]="'bottom'" [(colorPicker)]="tab.colour" class="colour-picker-button"></button></label>
                  <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
                  <app-uri-select [showTagMatch]="true" [enableMultiSelect]="true" [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
                </div>
                <div class="form-group input-group-sm">
                  <label>Display Type </label>
                  <select [(ngModel)]="tab.type" class="input-group form-select">
                    <option value="geojson">GEO Json</option>
                    <option value="tracker">Tracker</option>
                    <option value="heatmap">Heatmap</option>
                    <option value="signal">Signal</option>
                    <option value="speed">Speed</option>
                    <option value="fixed">Fixed Site</option>
                  </select>
                </div>
                <div class="form-group input-group-sm" *ngIf="tab.type == 'heatmap'">
                  <label>Weight</label>
                  <input type="number" min="50" max="100" placeholder="Weight" class="form-control" [(ngModel)]="tab.weight"/>     
                </div>
                <div class="form-group input-group-sm mt-2">
                  <input type="checkbox" [(ngModel)]="tab.useRssi" /> Weight with RSSI
                </div>                
                <div class="col-lg-12">
                  <div class="form-group input-group-sm">
                    <label>Display Name</label>
                    <input type="text" size="20" [(ngModel)]="tab.displayName" class="form-control"/>
                  </div>
                </div>
                <div class="form-group input-group-sm">
                  <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
                </div>
              </div>
              <div class="col-lg-8" *ngIf="tab.type == 'fixed'">
                    <table class="table">
                      <tr>
                          <th>Rule <!--<button class="btn btn-xs btn-default btn-circle">i</button>--></th><th><div class="input-group input-group-sm">
                            <select [(ngModel)]="newEventType" class="time-other form-select">
                              <option value="pin">Show Pin</option>
                              <option value="display">Show Value</option>
                              <option value="geojson">Display GEO JSON</option>
                            </select>
                            <span class="input-group-append"> 
                              <button type="button" class="btn btn-outline-default" (click)="addNewEvent(tab)">Add</button>
                            </span>
                          </div>
                        </th>
                        <th></th>
                      </tr>
                      <tr *ngIf="tab.events == null || tab.events.length == 0">
                          <td colspan="3">No Events Specified</td>
                      </tr>
                      <tr *ngFor="let event of tab.events">
                          <td>
                            <div class="input-group">
                              
                              <div class="input-group-prepend ">
                                <span class="input-group-addon form-control-sm">X</span>
                              </div>
    
                              <select [(ngModel)]="event.check" class="form-select form-select-sm">
                                <option value="lessThan">&lt;</option>
                                <option value="lessThanEqual">&lt;=</option>
                                <option value="greaterThan">&gt;</option>
                                <option value="greaterThanEqual">&gt;=</option>
                                <option value="equal">=</option>
                                <option value="notEqual">!=</option>
                              </select>
    
                              <div class="input-group-append" style="width:50%;">
                                <input type="text" class="form-control form-control-sm" style="height:31px" [(ngModel)]="event.match"/>
                              </div>
                                                        
                            </div>
                          </td>
                          <td>
                            <div *ngIf="event.type == 'pin'">
                              <button class="btn  btn-outline-default btn-sm" (click)="event.showMenu = !event.showMenu"><img style="height:22px" src="{{getPin(event.pin).options.iconUrl}}"/></button>
                              <div class="toggle-menu" *ngIf="event.showMenu">
                                  <button class="btn btn-outline-default btn-sm" *ngFor="let pin of pins" (click)="selectPin(event, pin)"><img style="height:22px" src="/{{pin.iconUrl}}"/></button>
                              </div>
                            </div>
                            <div *ngIf="event.type == 'geojson'">
                              <input *ngIf="event.geoJson == null" type="file" class="form-control" (change)="uploadShapeFile(event, $event.target.files)" placeholder="Upload file" accept=".json,.geojson"/>                          
                              <input *ngIf="event.geoJson" type="text" class="form-control" [(ngModel)]="event.geoJson"/>
                            </div>
                            <div *ngIf="event.type == 'display'">
                              Show Value
                            </div>
                          </td>
                          <td>
                              <a (click)="removeEvent(tab, event)"><i class="fa fa-minus"></i></a>
                          </td>
                      </tr>
                    </table>
              </div>
            </div>
          </tab>
        </tabset>
      </div>
    </div>
  </tab>
  <tab heading="Layers">
    <table class="table table-stripped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Default State</th>
          <th>Access Direct</th>
          <th>GeoJSON URL</th>
          <th><button class="btn btn-xs btn-primary" (click)="addLayer()">+</button></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="widget.layers == null || widget.layers.length == 0">
          <td colspan="3">No Layers Specified</td>
        </tr>
        <tr *ngFor="let layer of widget.layers">
          <td>
            <input type="textbox" [(ngModel)]="layer.name"/>
          </td>
          <td>
            <select [(ngModel)]="layer.type" class="input-group form-select">
              <option value="geojson">GEO JSON</option>
              <option value="esri">ESRI</option>
            </select>
          </td>
          <td>
            <div class="form-switch">
              <input type="checkbox" class="form-check-input" [(ngModel)]="layer.onByDefault">
            </div>
          </td>
          
          <td>
            <div class="form-switch">
              <input type="checkbox" class="form-check-input" [(ngModel)]="layer.accessDirectly">
            </div>
          </td>
          <td>
            <input type="textbox" [(ngModel)]="layer.url"/>
          </td>
          <td>
              <a (click)="removeLayer(layer)"><i class="fa fa-minus"></i></a>
          </td>
        </tr>
      </tbody>      
    </table>
  </tab>
</tabset>

